//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  Button as MuiButton,
} from '@mui/material';
import React, { useState } from 'react';
import styled from 'styled-components';
//  -- Components ---------------------
import { Button, Card, Col, Divider, Input, Modal, Row, Select } from 'antd';
import Loading from 'components/Loading';
//  -- Constants ----------------------
import { filter, find, get, isEmpty, sortBy } from 'lodash';
//  -- Thunks -------------------------
import PasswordRevealInline from 'components/PasswordRevealInline';
import { CanvasCourseModal } from 'components/admin/bookmaps/CanvasCourseModal';
import { ClasslinkCourseModal } from 'components/admin/bookmaps/ClasslinkCourseModal';
import { CleverCourseUpdate } from 'components/admin/bookmaps/CleverUpdateModal';
import { GooleCourseModal } from 'components/admin/bookmaps/GoogleCourseModal';
import { SchoologyUpdateModal } from 'components/admin/bookmaps/SchoologyUpdateModal';
import VocabAccessModal from 'components/admin/VocabPermission';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import Login_as from 'features/forms/admin/Login_as';
import { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useGoogleCourseMapByDistrict } from 'store/booksUnits/selectors';
import {
  handleGetCanvasCourseByDist,
  handleGetClasslinkCourseByDist,
  handleGetCleverCourseByDist,
  handleListSchoologyCourcesByDistId,
} from 'store/booksUnits/thunks';
import { useLicences } from 'store/licences/selectors';
import { useCurrentOrg } from 'store/organizations/selectors';
import { handleGetGlobalUserDetail, handleGetGlobalUserSearch, handleGetOrganization } from 'store/organizations/thunks';
import AdminSearchTable from './AdminSearchTable';
import { COLOR } from 'utils/constants/color';
import { Visibility } from '@mui/icons-material';
import GlobalUserDetails from './GlobalUserDetails';
const BORDERCOLOR = ['rgb(200,109,152)', 'rgb(146,158,227)', 'rgb(80,233,200)', 'rgb(238,206,151)'];

const TableScrollArea = styled(TableContainer)`
  width: 100%;
  margin-top: 20px;
  max-height: min(560px, calc(100vh - 240px));
  border-radius: 8px;
  border: 1px solid #ebebeb;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
`;
const StableWrapperMain = styled.div``;

const OverViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 20px;
`;
const OverViewLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
`;
const OverViewValue = styled.span`
  font-size: 17px;
  font-weight: 500;
  cursor: pointer;
`;
const FilterContainer = styled.span`
  font-size: 17px;
  font-weight: 500;
  cursor: pointer;
`;

const ViewDemo = styled.span`
  text-align: left;
  color: ${(p) => p.color};
`;
const ProfileContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

const OverViewDist = styled.p`
  font-size: 20px;
  font-weight: 600;
`;

const USER_TABLE_COLS = 9;
const ORG_TABLE_COLS = 8;

const bodyCellSx = {
  textAlign: 'left',
  fontSize: '0.8125rem',
  py: 1,
  px: 1.5,
  verticalAlign: 'middle',
};

const TableCells = ({
  row,
  setData,
  setModal2Open,
  checkIntegration,
  modal2Open,
  loading,
  fetchApis = () => {},
}) => {
  if (row?.role === 'owe_admin') return null;
  return (
    <TableRow
      hover
      sx={{ cursor: 'pointer', '&:nth-of-type(even)': { bgcolor: 'rgba(0,0,0,0.02)' } }}
      onClick={() => setData(row)}
    >
      <TableCell
        sx={{ ...bodyCellSx, cursor: 'pointer' }}
        onClick={() => {
          setModal2Open(!modal2Open);
        }}
      >
        {row.firstName}{' '}
      </TableCell>
      <TableCell
        sx={{ ...bodyCellSx, color: BORDERCOLOR[2], cursor: 'pointer' }}
        onClick={() => {
          setModal2Open(!modal2Open);
        }}
      >
        {row.lastName}{' '}
      </TableCell>
      <TableCell sx={{ ...bodyCellSx, color: BORDERCOLOR[0], cursor: 'pointer' }}>
        {get(row, 'username', '')}
      </TableCell>
      <TableCell
        sx={{ ...bodyCellSx, color: BORDERCOLOR[0], cursor: 'pointer' }}
        onClick={(e) => e.stopPropagation()}
      >
        <PasswordRevealInline userId={get(row, 'id')} username={get(row, 'username')} />
      </TableCell>
      <TableCell sx={{ ...bodyCellSx, color: BORDERCOLOR[0] }}>{get(row, 'districtName', '') || ''}</TableCell>
      <TableCell sx={{ ...bodyCellSx, color: BORDERCOLOR[1] }}>{get(row, 'schoolName', '')}</TableCell>
      <TableCell sx={{ ...bodyCellSx, color: BORDERCOLOR[1] }}>
        {row.role === 'owe_admin' ? 'owe admin' : get(row, 'role', '')}
      </TableCell>
      <TableCell sx={{ ...bodyCellSx, color: 'rgb(200, 109, 152)' }}>{checkIntegration(row)}</TableCell>
      <TableCell sx={{ ...bodyCellSx, color: 'rgb(200, 109, 152)' }} onClick={(e) => e.stopPropagation()}>
        <MuiButton
          disabled={loading === get(row, 'id')}
          sx={{ minWidth: 44, px: 0.5 }}
          variant="text"
          onClick={(e) => {
            e.stopPropagation();
            fetchApis(get(row, 'id'));
          }}
        >
          {loading === get(row, 'id') ? <Loading size={15} /> : <Visibility sx={{ color: COLOR.green }} />}
        </MuiButton>
      </TableCell>
    </TableRow>
  );
};

const substract = (a, b) => {
  let _a = parseInt(a);
  let _b = parseInt(b);
  if (isNaN(_a)) _a = 0;
  if (isNaN(_b)) _b = 0;
  return _a - _b;
};

const isDistrictOrgRow = (row) => String(get(row, 'typeId', '')).toLowerCase() === 'district';

const isSchoolOrgRow = (row) => String(get(row, 'typeId', '')).toLowerCase() === 'school';

const OrgTableCells = ({
  row,
  setData,
  setModal2Open,
  checkIntegration,
  modal2Open,
  districtName,
}) => {
  const isDistrict = isDistrictOrgRow(row);
  return (
    <TableRow
      hover
      sx={{ cursor: 'pointer', '&:nth-of-type(even)': { bgcolor: 'rgba(0,0,0,0.02)' } }}
      onClick={() => {
        setData(row);
      }}
    >
      <TableCell
        sx={{ ...bodyCellSx, cursor: 'pointer' }}
        onClick={() => {
          setModal2Open(!modal2Open);
        }}
      >
        {`${row.displayName} ${row.demo ? '(Demo)' : ''}`}
      </TableCell>
      <TableCell
        sx={{ ...bodyCellSx, color: BORDERCOLOR[2], cursor: 'pointer' }}
        onClick={() => {
          setModal2Open(!modal2Open);
        }}
      >
        {isDistrict ? (
          row.countSchool
        ) : (
          <>
            {get(districtName, 'displayName', '')}{' '}
            <ViewDemo color={BORDERCOLOR[3]}>{get(districtName, 'demo', '') && '(Demo)'}</ViewDemo>
          </>
        )}{' '}
      </TableCell>
      <TableCell sx={{ ...bodyCellSx, color: BORDERCOLOR[0], cursor: 'pointer' }}>
        {isDistrict ? (
          get(row, 'districtTeacherCount', null) != null ? get(row, 'districtTeacherCount') : '-'
        ) : (
          <>{get(row, 'licenses', '') || 0}</>
        )}
      </TableCell>
      <TableCell sx={{ ...bodyCellSx, color: BORDERCOLOR[0], cursor: 'pointer' }}>
        {isDistrict ? (
          get(row, 'districtStudentCount', null) != null ? get(row, 'districtStudentCount') : '-'
        ) : (
          <>{row.maxCount != 'undefined' ? row.maxCount : 0}</>
        )}
      </TableCell>
      <TableCell sx={{ ...bodyCellSx, color: BORDERCOLOR[0] }}>
        {isDistrict ? (
          <>{get(row, 'allocated_License', '0') || 0}</>
        ) : (
          <>{substract(row.licenses, row.maxCount != 'undefined' ? row.maxCount : 0)}</>
        )}
      </TableCell>
      <TableCell sx={{ ...bodyCellSx, color: BORDERCOLOR[1] }}>
        {isDistrict ? (
          <>{get(row, 'used_License', '0')}</>
        ) : isSchoolOrgRow(row) ? (
          <>
            {get(row, 'districtTeacherCount', null) != null ||
            get(row, 'districtteachercount', null) != null
              ? (get(row, 'districtTeacherCount') ?? get(row, 'districtteachercount'))
              : get(row, 'teacherCount', '-')}
          </>
        ) : (
          <>{get(row, 'districtName', '')}</>
        )}
      </TableCell>
      <TableCell sx={{ ...bodyCellSx, color: BORDERCOLOR[1] }}>
        {isDistrict ? (
          <>{get(row, 'available_Licenses', '0')}</>
        ) : isSchoolOrgRow(row) ? (
          <>
            {get(row, 'districtStudentCount', null) != null ||
            get(row, 'districtstudentcount', null) != null
              ? (get(row, 'districtStudentCount') ?? get(row, 'districtstudentcount'))
              : get(row, 'studentCount', '-')}
          </>
        ) : (
          <>{get(row, 'schoolName', '')}</>
        )}
      </TableCell>
      <TableCell sx={{ ...bodyCellSx, color: 'rgb(200, 109, 152)' }}>{checkIntegration(row)}</TableCell>
    </TableRow>
  );
};

const AdminGlobalSearch = ({ districts, allSchools, userloading, onTabsJump = () => null }) => {
  const showAlert = useAlert();
  const [globalSearch, setGlobalSearch] = useState('');
  const [globalSearchFirst, setGlobalSearchFirst] = useState('');
  const [globalSearchLast, setGlobalSearchLast] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentOrg = useCurrentOrg();
  const licencesCount = useLicences();
  const [data, setData] = useState('');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [modal2Open, setModal2Open] = useState(false);
  const [filteredDistricts, setFilteredDistricts] = useState([]);
  const [integrationFilter, setIntegrationFilter] = useState([]);
  const [enableLoader, setEnableLoader] = useState(-1);
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [loader, setLoader] = useState(false);
  const [searchLoader, setSearchLoader] = useState(false);
  const [loaderType, setLoaderType] = useState('');
  const [distBookMapData, setDistBookMapData] = useState({});
  const [distBGoogleookMapData, setDistGoogleBookMapData] = useState({});
  const [openModalType, setOpenModalType] = useState('');
  const googleClassRoomCourseMap = useGoogleCourseMapByDistrict();
  const [selectedOrg, setSelectedOrg] = useState({});
  const [classNo, setClassNo] = useState();
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const isOrgResultsView = selectedFilter === 'district' || selectedFilter === 'school';
  const tableColSpan = isOrgResultsView ? ORG_TABLE_COLS : USER_TABLE_COLS;

  const fetchSearchedUser = async (offset = 0, limit = rowsPerPage) => {
    if (globalSearch?.length === 0 && globalSearchFirst?.length === 0 && globalSearchLast?.length === 0) return;
    setSearchLoader(true);
    
    let searchTitle = '';
    if (selectedFilter === 'district' || selectedFilter === 'school') {
      searchTitle = globalSearch?.trim() || '';
    } else {
      const trimmedFirst = globalSearchFirst?.trim() || '';
      const trimmedLast = globalSearchLast?.trim() || '';
      
      if (trimmedFirst && trimmedLast) {
        searchTitle = `${trimmedFirst} ${trimmedLast}`;
      } else if (trimmedFirst) {
        searchTitle = trimmedFirst;
      } else if (trimmedLast) {
        searchTitle = trimmedLast;
      }
    }
    
    const searchUser = {
      title: searchTitle,
      role: selectedFilter,
      offset: offset,
      limit: limit
    };
    const { data, totalPages } = await dispatch(handleGetGlobalUserSearch(searchUser));

    if (data?.length > 0) {
      showAlert('Data found successfully!', 'success');
    } else {
      showAlert('No data found, please try with different user!', 'error');
    }
    setTotalCount(totalPages);
    setIntegrationFilter(data);
    // setFilteredDistricts(data);
    setSearchLoader(false);
  };

  const fetchBooksMapping = async (data) => {
    if (data?.schoolId) {
      setLoaderType('schoology');
      const district_book_map = await handleListSchoologyCourcesByDistId(data?.id, 'district');
      if (district_book_map && district_book_map.success) {
        if (district_book_map.data && district_book_map.data.length > 0) {
          setDistBookMapData(district_book_map.data[0]);
        } else {
          setDistBookMapData({
            displayName: data.displayName,
            schoolId: data?.schoolId,
            books: [],
            district_id: data.id,
            mapping_type: 'district',
          });
        }
      }
      setLoaderType('');
    } else if (data?.canvas_id) {
      setLoaderType('canvas');
      const district_book_map = await handleGetCanvasCourseByDist(data?.id);
      if (district_book_map && district_book_map.success) {
        if (district_book_map.data && district_book_map.data.length > 0) {
          setDistBookMapData(district_book_map.data[0]);
        } else {
          setDistBookMapData({
            displayName: data.displayName,
            courseId: null,
            canvas_id: data.canvas_id,
            orgId: data.id,
            books: [],
          });
        }
      }
      setLoaderType('');
    } else if (data?.classlinkid) {
      setLoaderType('classlink');
      const district_book_map = await handleGetClasslinkCourseByDist(data?.id);
      if (district_book_map && district_book_map.success) {
        if (district_book_map.data && district_book_map.data.length > 0) {
          setDistBookMapData(district_book_map.data[0]);
        } else {
          setDistBookMapData({
            displayName: data.displayName,
            courseId: null,
            classSourceId: data.classlinkid,
            districtId: data.id,
            tenantId: data.classlinkTenantId,
            orgId: data.id,
            books: [],
          });
        }
      }
      setLoaderType('');
    } else if (data?.cleverId) {
      setLoaderType('clever');
      const district_book_map = await handleGetCleverCourseByDist(data?.id);
      if (district_book_map && district_book_map.success) {
        if (district_book_map.data && district_book_map.data.length > 0) {
          setDistBookMapData(district_book_map.data[0]);
        } else {
          setDistBookMapData({
            displayName: data.displayName,
            courseId: null,
            cleverDistId: data.cleverId,
            orgId: data.id,
            clever_course_id: null,
            books: [],
          });
        }
      }
      setLoaderType('');
    }
  };

  useEffect(() => {
    if (integrationFilter) {
      setFilteredDistricts(integrationFilter);
    }
  }, [integrationFilter]);

  const setFilterdDistrict = (dist) => {
    if (dist) {
      const cOrg = find(dist, (d) => d.id == get(currentOrg, 'id'));
      if (cOrg) {
        const sortedDist = sortBy(
          filter(dist, (d) => d.id != get(currentOrg, 'id')),
          ['displayName'],
        );
        const res = [cOrg, ...sortedDist];
        setIntegrationFilter(res);
      } else {
        setIntegrationFilter(sortBy(dist, ['displayName']));
      }
    } else {
      setIntegrationFilter([]);
    }
  };
  // useEffect(() => {
  //     setFilterdDistrict(districts)
  // }, [districts])
  // useEffect(() => {
  //   setPage(0);
  // }, [filteredDistricts]);

  const handleSearchDistrict = (event) => {
    if (event.target.value && event.target.value.length > 0) {
      var search = event.target.value;
      setGlobalSearch(search);
    } else {
      setGlobalSearch('');
    }
  };

  const handleSearchUserFirst = (event) => {
    if (event.target.value && event.target.value.length > 0) {
      var search = event.target.value;
      setGlobalSearchFirst(search);
    } else {
      setGlobalSearchFirst('');
    }
  };

  const handleSearchUserLast = (event) => {
    if (event.target.value && event.target.value.length > 0) {
      var search = event.target.value;
      setGlobalSearchLast(search);
    } else {
      setGlobalSearchLast('');
    }
  };

  const handleChange = (value) => {
    setSelectedFilter(value);
    setGlobalSearch('');
    setGlobalSearchFirst('');
    setGlobalSearchLast('');
    setPage(0);
    setTotalCount(0);
    setIntegrationFilter([]);
    setFilteredDistricts([]);
    setSearchLoader(false);
    setModal2Open(false);
    setData('');
  };
  const onFilterApply = (value) => {
    switch (value) {
      case 'all':
        setFilteredDistricts(integrationFilter);
        break;
      case 'clever':
        const filterClever = filter(integrationFilter, (obj) => obj.cleverId);
        setFilteredDistricts(filterClever);
        break;
      case 'classlink':
        const filterClasslink = filter(
          integrationFilter,
          (obj) => obj.classlinkid || obj.classlinkTenantId,
        );
        setFilteredDistricts(filterClasslink);
        break;
      case 'schoology':
        const filterSchoology = filter(integrationFilter, (obj) => obj.schoolId);
        setFilteredDistricts(filterSchoology);
        break;
      case 'canvas':
        const filterCanvas = filter(integrationFilter, (obj) => obj.canvas_id);
        setFilteredDistricts(filterCanvas);
        break;
      case 'google':
        const filter_Google = filter(integrationFilter, (obj) =>
          find(googleClassRoomCourseMap, ['orgId', obj.id]),
        );
        setFilteredDistricts(filter_Google);
        break;
      default:
        break;
    }
  };
  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);

    fetchSearchedUser(0, newRowsPerPage);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    const offset = newPage * rowsPerPage;
    fetchSearchedUser(offset, rowsPerPage);
  };
  const handleCurrentOrgLoader = async (data, jumPage) => {
    setEnableLoader(data?.id);
    const has_google_course = find(googleClassRoomCourseMap, ['orgId', data.id]);
    if (has_google_course) {
      setDistGoogleBookMapData(has_google_course);
    } else {
      setDistGoogleBookMapData({});
    }
    setSelectedOrg(data);
    fetchBooksMapping(data, jumPage === 'see_schools');
    setLoader(true);
    if (currentOrg?.id !== data?.id) {
      localStorage.setItem('lastActiveOrgAdmin', data?.id);
      await dispatch(handleGetOrganization(data?.id));
      setLoader(false);
    } else {
      setLoader(false);
    }
    if (jumPage === 'see_schools') {
      onTabsJump('see_schools', data);
    }
    if (jumPage === 'see_teachers') {
      onTabsJump('see_teachers', data);
    }
    if (jumPage === 'see_students') {
      onTabsJump('see_students', data);
    }
    // setLoader(false);
  };
  const addTeachers = (value) => {
    const editData = {
      userData: data,
      isEdit: true,
      from: 'global',
    };
    const addData = {
      userData: null,
      isEdit: false,
      from: 'global',
    };
    if (value == 'edit') {
      navigate('/add-users', { state: editData });
    } else {
      navigate('/add-users', { state: addData });
    }
  };

  const addSchools = (value) => {
    const editData = {
      editSchool: true,
      school: data,
      from: 'global',
    };
    const addData = {
      school: null,
      editSchool: false,
      from: 'global',
    };
    if (value == 'edit') {
      navigate('/add-schools', { state: editData });
    } else {
      navigate('/add-schools', { state: addData });
    }
  };
  const getDisplayName = (data) => {
    if (isSchoolOrgRow(data)) {
      return get(data, 'displayName', '');
    } else if (isDistrictOrgRow(data)) {
      return get(data, 'displayName', '');
    } else {
      return `${get(data, 'firstName', '')} ${get(data, 'lastName', '')}`;
    }
  }
  const checkIntegration = (value) => {
    const has_google = find(googleClassRoomCourseMap, ['orgId', value.id]);
    let googleIntText = ``;
    if (has_google) {
      googleIntText = `Google Classroom`;
    }
    if (value.cleverId) {
      return `Clever ${has_google ? ',' : ''}${has_google ? googleIntText : ''}`;
    } else if (value.classlinkid) {
      return `Classlink${has_google ? ',' : ''}${has_google ? googleIntText : ''}`;
    } else if (value.canvas_id) {
      return `Canvas${has_google ? ',' : ''}${has_google ? googleIntText : ''}`;
    } else if (value.schoologyid) {
      return `Schoology${has_google ? ',' : ''}${has_google ? googleIntText : ''}`;
    } else if (has_google) {
      return `${googleIntText}`;
    } else if (value.googleId) {
      return "Google Classroom"
    } else {
      return '-';
    }
  };

  const fetchApis = async (id) => {
    setLoading(id);
    const fetchUserDetails = await handleGetGlobalUserDetail(id)
    setUserDetails(fetchUserDetails);
    setOpenModal(true);
    setLoading('');
  }

  return (
    <>
      <CleverCourseUpdate
        openEditModal={openModalType == 'clever'}
        setOpenEditModal={() => setOpenModalType(null)}
        selectedData={distBookMapData}
      />
      <SchoologyUpdateModal
        openEditModal={openModalType == 'schoology'}
        setOpenEditModal={() => setOpenModalType(null)}
        selectedData={distBookMapData}
      />
      <ClasslinkCourseModal
        openEditModal={openModalType == 'classlink'}
        setOpenEditModal={() => setOpenModalType(null)}
        selectedData={distBookMapData}
      />
      <CanvasCourseModal
        openEditModal={openModalType == 'canvas'}
        setOpenEditModal={() => setOpenModalType(null)}
        selectedData={distBookMapData}
      />
      <GooleCourseModal
        openEditModal={openModalType == 'google'}
        setOpenEditModal={() => setOpenModalType(null)}
        selectedData={distBGoogleookMapData}
        orgInfo={selectedOrg}
      />

      <GlobalUserDetails setOpenModal={setOpenModal} openModal={openModal} userDetails={userDetails} />
      <StableWrapperMain>
        <Row>
          <Col>
            <OverViewDist>Global Search</OverViewDist>
          </Col>
        </Row>
        <FilterContainer className="FilterHeading">
          <Card type="inner" title="Filters">
            <Row>
              <Col xs={24} lg={4} md={12} className="ColCardPadding">
                <Card style={{ width: '100%' }}>
                  <Select
                    bordered={false}
                    value={selectedFilter}
                    style={{ width: '100%', fontSize: 13 }}
                    onChange={handleChange}
                    options={[
                      { value: 'all', label: 'All' },
                      { value: 'teacher', label: 'Teacher' },
                      { value: 'student', label: 'Student' },
                      { value: 'district', label: 'District' },
                      { value: 'school', label: 'School' },
                    ]}
                  />
                </Card>
              </Col>
              {selectedFilter === 'district' || selectedFilter === 'school' ? (
                <Col xs={24} lg={17} md={12} className="ColCardPadding" style={{ marginLeft: '5px' }}>
                  <Card style={{ width: '100%' }}>
                    <Input
                      placeholder="Search user by name"
                      bordered={false}
                      style={{ height: '32px' }}
                      value={globalSearch}
                      onChange={handleSearchDistrict}
                      onPressEnter={() => fetchSearchedUser(0, rowsPerPage)}
                    />
                  </Card>
                </Col>
              ) : (
                <>
                  <Col xs={24} lg={8} md={12} className="ColCardPadding" style={{ marginLeft: '5px' }}>
                    <Card style={{ width: '100%' }}>
                      <Input
                        placeholder="Search user by first name"
                        bordered={false}
                        style={{ height: '32px' }}
                        value={globalSearchFirst}
                        onChange={handleSearchUserFirst}
                        onPressEnter={() => fetchSearchedUser(0, rowsPerPage)}
                      />
                    </Card>
                  </Col>
                  <Col xs={24} lg={9} md={12} className="ColCardPadding" style={{ marginLeft: '5px' }}>
                    <Card style={{ width: '100%' }}>
                      <Input
                        placeholder="Search user by last name"
                        bordered={false}
                        style={{ height: '32px' }}
                        value={globalSearchLast}
                        onChange={handleSearchUserLast}
                        onPressEnter={() => fetchSearchedUser(0, rowsPerPage)}
                      />
                    </Card>
                  </Col>
                </>
              )}
              <Col xs={24} lg={2} md={12} className="ColCardPadding adminSrchBtn" style={{ marginLeft: '5px' }}>
                <Card style={{ width: '100%' }}>
                  <Button type="primary" ghost onClick={() => fetchSearchedUser(0, rowsPerPage)}>
                    {searchLoader ? <Loading size={18} /> : 'Search'}
                  </Button>
                </Card>
              </Col>
            </Row>
          </Card>
        </FilterContainer>
        <TableScrollArea>
          <Table
            stickyHeader
            size="small"
            aria-label="Global search results"
            sx={{ minWidth: 960, width: '100%' }}
          >
            <AdminSearchTable selectedFilter={selectedFilter} />
            <TableBody className="setTabletTd">
              {isEmpty(filteredDistricts) &&
                (searchLoader ? (
                  <TableRow>
                    <TableCell colSpan={tableColSpan} sx={{ textAlign: 'center', py: 4, border: 0 }}>
                      <Loading size={30} />
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableRow>
                    <TableCell colSpan={tableColSpan} sx={{ textAlign: 'center', py: 3, border: 0 }}>
                      No results
                    </TableCell>
                  </TableRow>
                ))}
              {!isEmpty(filteredDistricts) &&
                filteredDistricts.map((row) => {
                  const getLicences = find(
                    licencesCount,
                    (obj) => obj.districtId == row.id && obj.schoolId == null,
                  );
                  const filterSchoolbyParent = filter(
                    allSchools,
                    (obj) => obj.parentId == row.id,
                  ).length;
                  const isDistrictRow = isDistrictOrgRow(row);
                  if (isDistrictRow) {
                    const apiSchools =
                      get(row, 'districtSchoolCount') ?? get(row, 'districtschoolcount');
                    if (apiSchools != null) row.countSchool = Number(apiSchools);
                    else row.countSchool = filterSchoolbyParent;
                    const apiAlloc =
                      get(row, 'districtAllocatedLicense') ??
                      get(row, 'districtallocatedlicense');
                    if (apiAlloc != null) {
                      row.allocated_License = apiAlloc;
                      row.used_License =
                        get(row, 'districtUsedLicense') ?? get(row, 'districtusedlicense');
                      row.available_Licenses =
                        get(row, 'districtAvailableLicenses') ??
                        get(row, 'districtavailablelicenses');
                    } else {
                      row.allocated_License = get(getLicences, 'allocatedLicense', '0');
                      row.used_License = get(getLicences, 'usedLicense', '0');
                      row.available_Licenses = get(getLicences, 'availableLicenses', '0');
                    }
                    row.districtTeacherCount =
                      get(row, 'districtTeacherCount') ?? get(row, 'districtteachercount');
                    row.districtStudentCount =
                      get(row, 'districtStudentCount') ?? get(row, 'districtstudentcount');
                  } else {
                    row.countSchool = filterSchoolbyParent;
                    row.allocated_License = get(getLicences, 'allocatedLicense', '0');
                    row.used_License = get(getLicences, 'usedLicense', '0');
                    row.available_Licenses = get(getLicences, 'availableLicenses', '0');
                  }
                  const schoolFromState = find(allSchools, (obj) => obj.id === row.orgId);
                  const districtFromSchool = find(districts, (obj) => obj.id === schoolFromState?.parentId);
                  const districtNameOrg = find(districts, (obj) => obj.id == row.parentId);
                  if (!isOrgResultsView) {
                    row.schoolName =
                      get(row, 'schoolName', '') || get(schoolFromState, 'displayName', '') || '';
                    row.districtName =
                      get(row, 'districtName', '') || get(districtFromSchool, 'displayName', '') || '';
                  } else {
                    row.schoolName = get(schoolFromState, 'displayName', '');
                    row.districtName = get(districtNameOrg, 'displayName', '');
                  }
                  return isOrgResultsView ? (
                    <OrgTableCells
                      key={row.id}
                      row={row}
                      setData={setData}
                      setModal2Open={setModal2Open}
                      checkIntegration={checkIntegration}
                      modal2Open={modal2Open}
                      districtName={districtNameOrg}
                    />
                  ) : (
                    <TableCells
                      key={row.id}
                      row={row}
                      setData={setData}
                      setModal2Open={setModal2Open}
                      checkIntegration={checkIntegration}
                      modal2Open={modal2Open}
                      loading={loading}
                      fetchApis={fetchApis}
                    />
                  );
                })}
            </TableBody>
            <TableFooter>
              <TableRow>
                {!isEmpty(filteredDistricts) && (
                  <TablePagination
                    colSpan={tableColSpan}
                    count={totalCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[10, 50, 100]}
                    backIconButtonProps={{
                      color: 'secondary',
                    }}
                    nextIconButtonProps={{ color: 'secondary' }}
                  />
                )}
              </TableRow>
            </TableFooter>
          </Table>
        </TableScrollArea>
      </StableWrapperMain>
      <Modal
        footer={null}
        title={getDisplayName(data)}
        centered
        open={modal2Open}
        onOk={() => setModal2Open(false)}
        onCancel={() => setModal2Open(false)}
        width={'60%'}
        className="FilterHeading"
      >
        <ProfileContainer>
          <Button
            type="primary"
            ghost
            onClick={() => (isSchoolOrgRow(data) ? addSchools('edit') : addTeachers('edit'))}
          >
            Edit Profile
          </Button>
          {!get(data, 'typeId') && (
            <>
              <Login_as user={data} />
              <VocabAccessModal id={data?.id} type={'teacher'} />
            </>
          )}
        </ProfileContainer>
        <Card style={{ marginTop: 16 }} type="inner" title="Detail View">
          <Row>
            <Col xs={24} lg={24}></Col>
            <Col xs={24} lg={12}>
              <OverViewContainer>
                <OverViewLabel>
                  {isSchoolOrgRow(data)
                    ? 'Schools Name'
                    : isDistrictOrgRow(data)
                      ? 'Districts Name'
                      : 'First name'}
                </OverViewLabel>
                <OverViewValue>
                  {isSchoolOrgRow(data) || isDistrictOrgRow(data)
                    ? get(data, 'displayName', '')
                    : get(data, 'firstName', '')}
                </OverViewValue>
              </OverViewContainer>
              <OverViewContainer>
                <OverViewLabel>
                  {isSchoolOrgRow(data)
                    ? 'Districts Name'
                    : isDistrictOrgRow(data)
                      ? 'Licenses'
                      : 'User Name'}
                </OverViewLabel>
                <OverViewValue>
                  {isSchoolOrgRow(data)
                    ? get(data, 'districtName', '')
                    : isDistrictOrgRow(data)
                      ? get(data, 'allocated_License', '')
                      : get(data, 'username', '')}
                </OverViewValue>
              </OverViewContainer>

              <OverViewContainer>
                <OverViewLabel>
                  {isSchoolOrgRow(data)
                    ? 'Licenses'
                    : isDistrictOrgRow(data)
                      ? 'Licenses available'
                      : 'Created At'}
                </OverViewLabel>
                <OverViewValue>
                  {isSchoolOrgRow(data)
                    ? get(data, 'licenses', '')
                    : isDistrictOrgRow(data)
                      ? get(data, 'available_Licenses', '')
                      : get(data, 'date', '')}
                </OverViewValue>
              </OverViewContainer>
            </Col>
            <Col xs={24} lg={12}>
              <OverViewContainer>
                <OverViewLabel>
                  {isSchoolOrgRow(data)
                    ? 'Licenses available'
                    : isDistrictOrgRow(data)
                      ? 'Licenses used'
                      : 'Last name'}
                </OverViewLabel>
                <OverViewValue>
                  {isSchoolOrgRow(data)
                    ? substract(data.licenses, data.maxCount != 'undefined' ? data.maxCount : 0)
                    : isDistrictOrgRow(data)
                      ? get(data, 'used_License', '')
                      : get(data, 'lastName', '')}
                </OverViewValue>
              </OverViewContainer>
              <OverViewContainer>
                <OverViewLabel>
                  {isSchoolOrgRow(data)
                    ? 'Licenses used'
                    : isDistrictOrgRow(data)
                      ? 'Integration'
                      : 'Password'}
                </OverViewLabel>
                <OverViewValue>
                  <OverViewValue>
                    {isSchoolOrgRow(data)
                      ? get(data, 'maxCount', '') !== 'undefined' &&
                        get(data, 'maxCount', '') !== ''
                        ? get(data, 'maxCount', '')
                        : 0
                      : isDistrictOrgRow(data)
                        ? checkIntegration(data)
                        : <PasswordRevealInline userId={data?.id} username={data?.username} />}
                  </OverViewValue>
                </OverViewValue>
              </OverViewContainer>
            </Col>
          </Row>
          <Divider />
          {isSchoolOrgRow(data) || isDistrictOrgRow(data) ? null : (
            <Row>
              <Col xs={12} lg={12}>
                <OverViewContainer>
                  <OverViewLabel>School Name</OverViewLabel>
                  <OverViewValue
                    style={{ color: 'rgb(20, 100, 255)', cursor: 'pointer' }}
                    onClick={() => onTabsJump('see_schools', data)}
                  >
                    {get(data, 'schoolName', '')}
                  </OverViewValue>
                </OverViewContainer>
              </Col>
              <Col xs={12} lg={12}>
                <OverViewContainer>
                  <OverViewLabel>Classes</OverViewLabel>
                  <OverViewValue
                    style={{ color: 'rgb(20, 100, 255)', cursor: 'pointer' }}
                    onClick={() => onTabsJump('see_classes', data)}
                  >
                    {classNo}
                  </OverViewValue>
                </OverViewContainer>
              </Col>
            </Row>
          )}
        </Card>
      </Modal>
    </>
  );
};


//  ----------------------------------------------------------------------------
//  Redux
//  ----------------------------------------------------------------------------
const mapStateToProps = (state) => ({
  districts: state.districts,
  allSchools: state.allSchools,
});

export default connect(mapStateToProps, null)(AdminGlobalSearch);
